import React, { useEffect, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import DropDownSelector from "../micro_components/DropDownSelector";
import CreatorCard from "./CreatorCard";
import CreatorService from "../../services/CreatorService";
import DomainService from "../../services/DomainService";
import CreatorModal from "../micro_components/CreatorModal";
import ClearIcon from "@material-ui/icons/Clear";

//loader
import { css } from "@emotion/react";
import SyncLoader from "react-spinners/SyncLoader";

import "./CreatorList.css";

const override = css`
  position: abolute;
  left: vh;
`;

const loadingColor = "#8C9BD8";

const CreatorList = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const [creators, setCreators] = useState([]);
  const [domains, setDomains] = useState([]);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [newName, setNewName] = useState("");
  const [newLastName, setNewLastName] = useState("");
  const [selectedDomain, setSelectedDomain] = useState("0");
  const [searchName, setSearchName] = useState("");

  const [filteredCreators, setFilteredCreators] = useState([]);

  const [selectedNewDomain, setSelectedNewDomain] = useState(1);

  //loading
  const [loading, setLoading] = useState(true);

  //get creators and domains on load
  useEffect(() => {
    CreatorService.getAllDetailed()
      .then((response) => {
        // console.log("creators: ", response.data);
        setCreators(response.data);
        setFilteredCreators(response.data);
      })
      .catch((e) => console.log("error getting creators: " + e));

    DomainService.getAll()
      .then((response) => {
        response.data.unshift({ name: "All Domains", id: 0 });
        setDomains(response.data);
      })
      .catch((e) => console.log(e));
  }, []);

  //helper function to make sure not all components ar eopen at once in a row
  const collapseCards = (index) => {
    setOpenIndex(index);
  };

  //filter by domain
  const handleDomainSelect = (e) => {
    console.log("new domain: " + e);

    setSelectedDomain(e);
    search(searchName, e);
  };

  useEffect(() => {
    if (creators && creators.length > 0) {
      setLoading(false);
    }
  }, [creators]);

  const changeNewName = (event) => {
    console.log(event);
    setNewName(event.target.value);
  };

  const changeNewLastName = (event) => {
    setNewLastName(event.target.value);
  };

  const closeAddModal = () => {
    setAddModalOpen(false);
  };

  const submitNewCreator = () => {
    let newCreatorFormatted = {
      name: newName,
      lastName: newLastName,
      nationality: null,
      domain_id: selectedNewDomain ? selectedNewDomain : 1,
    };
    console.log(newCreatorFormatted);
    CreatorService.create(newCreatorFormatted)
      .then(() => {
        setAddModalOpen(false);
        CreatorService.getAll().then((response) => {
          setCreators(response.data);
          window.location.reload(false);
        });
      })
      .catch((e) => console.log("error creating new creator: " + e));
  };

  const searchByName = () => {
    let arr = creators;
    CreatorService.searchByName(searchName)
      .then((response) => {
        console.log(response.data);
        let creatorNames = response.data.map((c, i) => c.name);
        arr = creators.filter((creator) => {
          if (creatorNames.includes(creator.name)) {
            return true;
          }
          return false;
        });
        setFilteredCreators(arr);
      })
      .catch((e) => console.log("error search creators by name: " + e));
  };

  const clearSearchName = () => {
    setSearchName("");
    search("", selectedDomain);
  };

  const search = (name, domain) => {
    if (name === "") {
      let arr = [];
      arr = creators.filter((c) => {
        if (domain !== "0") {
          return c.domain_id === parseInt(domain);
        } else {
          return true;
        }
      });
      setFilteredCreators(arr);
    } else if (domain === "0") {
      searchByName();
    } else {
      let arr = creators;
      CreatorService.searchByName(searchName)
        .then((response) => {
          let creatorNames = response.data.map((c) => c.name);
          arr = creators.filter((creator) => {
            if (creatorNames.includes(creator.name) && creator.domain_id === parseInt(domain)) {
              return true;
            }
            return false;
          });
          setFilteredCreators(arr);
        })
        .catch((e) => console.log("error search creators by name: " + e));
    }
  };

  const updateSearchName = (e) => {
    setSearchName(e.target.value);
  };

  return loading ? (
    <div className="creator-list-container">
      <SyncLoader color={loadingColor} loading={loading} css={override} style={{ marginLeft: "auto auto" }} />
    </div>
  ) : (
    <div className="creator-list">
      <h1>Creators</h1>

      <div className="top-container">
        <div className="search-text-field">
          <TextField
            fullWidth
            size="medium"
            value={searchName}
            onChange={updateSearchName}
            onKeyDown={(e) => {
              if (e.key === "Enter") searchByName();
            }}
          />
          <button type="button" className="btn bg-transparent clear-icon creator-list-btn">
            <ClearIcon className={"clear-icon"} onClick={() => clearSearchName()} />
          </button>
        </div>
        <div className="search">
          <div className="search-icon">
            <SearchIcon onClick={searchByName} />
          </div>
        </div>
        {/* {console.log("DATA: ", domains)}
        {console.log("VALUE: ", selectedDomain)} */}
        <div className="secondary-buttons">
          <DropDownSelector
            data={domains}
            placeholder={"Domain"}
            value={selectedDomain}
            onChange={handleDomainSelect}
          />
          <IconButton aria-label="create" onClick={() => setAddModalOpen(true)}>
            <AddIcon fontSize="large" color="secondary" />
          </IconButton>
          <CreatorModal
            title={"Add New Creator"}
            isOpen={addModalOpen}
            onClose={closeAddModal}
            changeFirstName={changeNewName}
            changeLastName={changeNewLastName}
            onSubmit={submitNewCreator}
            initial={""}
            extraContent={
              <>
                <DropDownSelector
                  data={domains}
                  placeholder={"Domain"}
                  value={selectedNewDomain}
                  onChange={setSelectedNewDomain}
                />
              </>
            }
          />
        </div>
      </div>
      <div className="creator-cards">
        {filteredCreators &&
          filteredCreators.map((creator, index) => {
            return (
              <CreatorCard
                setCreators={setCreators}
                key={creator.id}
                creator={creator}
                collapseListener={openIndex}
                collapseTrigger={collapseCards}
                domains={domains}
                index={index}
                domain={domains.filter((d) => d.id === creator.domain_id)[0]}
              />
            );
          })}
      </div>
    </div>
  );
};

export default CreatorList;
